var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#ECF1FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 35C26.4926 35 27.5 35.9974 27.5 37.2277V37.2723C27.5 38.5026 26.4926 39.5 25.25 39.5C24.0074 39.5 23 38.5026 23 37.2723V37.2277C23 35.9974 24.0074 35 25.25 35Z",
    fill: "#4073F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9875 16.8598C21.1202 14.3567 24.6382 13.4402 27.7649 14.335C30.9007 15.2324 33.3916 17.9176 33.4966 21.3587C33.6019 24.8122 31.2632 27.6351 28.1701 28.6884L28.128 28.7022C27.2458 28.9784 27.0444 29.5834 27.0623 29.8642C27.1325 30.9663 26.3518 31.9204 25.3187 31.9953C24.2855 32.0702 23.3911 31.2375 23.3209 30.1354C23.1573 27.5659 24.9054 25.5535 27.0471 24.8717C28.9065 24.2313 29.7874 22.7625 29.7486 21.4888C29.7092 20.1987 28.7177 18.7493 26.7933 18.1986C24.8599 17.6453 22.8424 18.2828 21.7625 19.5503C21.066 20.3677 19.8802 20.4281 19.1139 19.6851C18.3476 18.9422 18.291 17.6772 18.9875 16.8598Z",
    fill: "#4073F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCompanyLogo);
export default __webpack_public_path__ + "static/media/top_company_logo.be9755554538148e602b44936af46e23.svg";
export { ForwardRef as ReactComponent };